// extracted by mini-css-extract-plugin
export default {"BoA-back-logo":"Backpage_BoA-back-logo__Z+-M5","BoA-individual-pages":"Backpage_BoA-individual-pages__ulK9O"};